import React, { Component } from 'react';
import { connect } from 'react-redux';
//import { Motion, spring } from 'react-motion';

import {
  createSolution,
  solutionOpen,
  setSolution,
  pushInteractions,
} from "../../actions";

import RedDyeOpen from "./img/RedDye-open.svg";
import RedDyeClosed from "./img/RedDye-close.svg";
import RedDyeEmptyOpen from "./img/RedDye-empty-open.svg";
import RedDyeEmptyClosed from "./img/RedDye-empty-close.svg";

import { withTranslation } from 'react-i18next'

const images = {
  "Red DyeOpen": RedDyeOpen,
  "Red DyeClosed": RedDyeClosed,
  "Red DyeEmptyOpen": RedDyeEmptyOpen,
  "Red DyeEmptyClosed": RedDyeEmptyClosed
}

class Graphics extends Component {
  toggleOpen = () => {
    this.props.solutionOpen({
      id: this.props.id,
      open: !this.props.open
    })
  }

  componentWillMount() {
    for(const image in images){
      if(!image.replace(this.props.type, '').includes(0)){
        const img = new Image();
        img.src = images[image];
      }
    }
  }

  getImg = () => {
    let reference = "Red Dye"
    if(this.props.volume === 0){
      reference += "Empty"
    }
    if(this.props.open){
      reference += "Open"
    } else {
      reference += "Closed"
    }
    return images[reference]
  }

  render() {
    return (
      <div className="graphics"
        onClick={this.toggleOpen}>
        <img
          style={{ pointerEvents: "none" }}
          src={this.getImg()}
          alt={this.props.t(this.props.type+' solution ' + ((this.props.open)?"opened":"closed") + ", Select to " + ((this.props.open)?"close":"open") + " the solution")}
          aria-live='assertive'
        />
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {

  return {
    id: ownProps.id,
    type: state.solution.solutions[ownProps.id - 1].type,
    open: state.solution.solutions[ownProps.id - 1].open,
    volume: state.solution.solutions[ownProps.id - 1].volume
  }
}
export default connect(mapStateToProps, {
  createSolution,
  solutionOpen,
  setSolution,
  pushInteractions,
})(withTranslation()(Graphics));
